export var getBlockProps = function getBlockProps(_ref) {
  var blocks = _ref.blocks,
    subscribeEmailTextAgreementURL = _ref.subscribeEmailTextAgreementURL,
    subscribeEmailURL = _ref.subscribeEmailURL,
    mailInputTexts = _ref.mailInputTexts,
    appButtonsDesktop = _ref.appButtonsDesktop;
  return blocks.reduce(function (acc, block) {
    if (block.type === 'links') {
      acc[block.type][block.title] = {
        type: block.type,
        title: block.title,
        data: block.data
      };
    } else if (block.type === 'groupLinks') {
      acc[block.type] = {
        type: block.type,
        title: block.title,
        data: block.data
      };
    } else if (block.type === 'subscribeMailingList') {
      acc[block.type] = {
        type: block.type,
        data: {
          subscribeEmailTextAgreementURL: subscribeEmailTextAgreementURL,
          subscribeEmailURL: subscribeEmailURL,
          texts: mailInputTexts,
          title: block.title
        }
      };
    } else if (block.type === 'beelineApps') {
      acc[block.type] = {
        title: block.title,
        type: block.type,
        data: {
          appLink: appButtonsDesktop.appLink,
          appLinkIcon: appButtonsDesktop.appLinkIcon,
          appQRCodeLinkIcon: appButtonsDesktop.appQRCodeLinkIcon,
          appQRCodeLinkIconWithText: appButtonsDesktop.appQRCodeLinkIconWithText
        }
      };
    }
    return acc;
  }, {
    links: {},
    groupLinks: {},
    subscribeMailingList: {},
    beelineApps: {}
  });
};